<template>
  <td v-html="iteration + meta.current_page" />
</template>
<script>
export default {
  props: {
    iteration: { default: 0 },
    meta: { default: false },
  },
};
</script>